module.exports = __webpack_public_path__ + "img/39.462a031f.png";